var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard__content"},[_c('h2',{staticClass:"cursive-font black--text mb-2"},[_vm._v("Activity")]),_c('time-tracking')],1)}
var staticRenderFns = []

export { render, staticRenderFns }